import { z } from 'zod';

const DISCOUNT_TYPES = {
    PERCENTAGE_DISCOUNT: 'PERCENTAGE_DISCOUNT',
    FIXED_AMOUNT_DISCOUNT: 'FIXED_AMOUNT_DISCOUNT',
    SHIPPING_DISCOUNT: 'SHIPPING_DISCOUNT',
};
const discountTypesValues = [
    DISCOUNT_TYPES.PERCENTAGE_DISCOUNT,
    DISCOUNT_TYPES.FIXED_AMOUNT_DISCOUNT,
    DISCOUNT_TYPES.SHIPPING_DISCOUNT,
];
const DiscountTypesSchema = z.enum(discountTypesValues);

export { DISCOUNT_TYPES, DiscountTypesSchema };
//# sourceMappingURL=DiscountTypes.js.map
